(() => {
  let activeForm;
  let activeRequest;
  let readyToCheckout = false;
  let redirecting = false;
  let redirectForm;
  let loadingFailed = false;
  const observers = new Map();
  const ready = () => !!window.liquidAjaxCart?.init;
  function sync(form) {
    const button = form.querySelector('[data-hdk-checkout]');
    const add = form.querySelector('.add-2-cart');
    if (!button || !add) return;
    const waiting = !ready();
    const busy = form === activeForm;
    const processing = form.closest('ajax-cart-product-form')?.hasAttribute('processing');
    button.disabled = add.disabled || waiting || processing || !!activeForm || redirecting;
    button.setAttribute('aria-disabled', String(button.disabled));
    button.setAttribute('aria-busy', String(busy || (waiting && !loadingFailed)));
    const label = button.querySelector('span');
    button.dataset.idleText ||= label.textContent;
    const text = busy || (waiting && !loadingFailed) ? button.dataset.loadingText : button.dataset.idleText;
    if (label.textContent !== text) label.textContent = text;
    const status = form.querySelector('[data-hdk-checkout-status]');
    if (status) {
      status.hidden = !waiting;
      const message = waiting ? status.dataset[loadingFailed ? 'failedText' : 'waitingText'] : '';
      if (status.textContent !== message) status.textContent = message;
    }
  }
  function initialize() {
    for (const [form, entry] of observers) {
      if (!form.isConnected) {
        entry.observer.disconnect();
        observers.delete(form);
        if (activeForm === form) reset();
      }
    }
    for (const button of document.querySelectorAll('[data-hdk-checkout]')) {
      const form = button.form;
      const add = form?.querySelector('.add-2-cart');
      if (!add) continue;
      if (observers.get(form)?.add !== add) {
        observers.get(form)?.observer.disconnect();
        const observer = new MutationObserver(() => sync(form));
        observer.observe(add, { attributes: true, attributeFilter: ['disabled'] });
        observer.observe(form.closest('ajax-cart-product-form'), { attributes: true, attributeFilter: ['processing'] });
        observers.set(form, { observer, add });
      }
      sync(form);
    }
  }
  function reset() {
    if (activeForm) delete activeForm.dataset.hdkCheckoutIntent;
    activeForm = null;
    activeRequest = null;
    readyToCheckout = false;
    redirecting = false;
    redirectForm?.remove();
    redirectForm = null;
    for (const form of observers.keys()) sync(form);
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('ajax-cart-product-form form')) return;
    if (activeForm || redirecting) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!event.submitter?.matches('[data-hdk-checkout]')) { delete form.dataset.hdkCheckoutIntent; return; }
    if (!ready() || form.closest('ajax-cart-product-form').hasAttribute('processing') || form.querySelector('.add-2-cart')?.disabled || !form.reportValidity()) {
      event.preventDefault(); event.stopImmediatePropagation(); sync(form); return;
    }
    activeForm = form;
    form.dataset.hdkCheckoutIntent = 'true';
    for (const other of observers.keys()) sync(other);
  }, true);
  document.addEventListener('liquid-ajax-cart:request-start', event => {
    const request = event.detail.requestState;
    if (request.requestType !== 'add') return;
    const initiator = request.info?.initiator;
    const form = initiator?.matches?.('form') ? initiator : initiator?.querySelector?.('form');
    if (form !== activeForm || form?.dataset.hdkCheckoutIntent !== 'true') return;
    request.info.hdkCheckout = true;
    activeRequest = request.info;
    delete form.dataset.hdkCheckoutIntent;
  });
  document.addEventListener('liquid-ajax-cart:request-end', event => {
    const request = event.detail.requestState;
    if (!activeRequest || request.info !== activeRequest) return;
    if (!request.responseData?.ok) { reset(); return; }
    readyToCheckout = true;
  });
  document.addEventListener('liquid-ajax-cart:queue-end', () => {
    if (!activeForm || !readyToCheckout || redirecting) return;
    readyToCheckout = false;
    redirecting = true;
    activeRequest = null;
    const button = activeForm.querySelector('[data-hdk-checkout]');
    redirectForm = document.createElement('form');
    redirectForm.method = 'post';
    redirectForm.action = button.dataset.cartUrl;
    redirectForm.hidden = true;
    const checkout = document.createElement('input');
    checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = '1';
    redirectForm.append(checkout); document.body.append(redirectForm);
    HTMLFormElement.prototype.submit.call(redirectForm);
  });
  const loadingTimer = setTimeout(() => {
    if (!ready()) { loadingFailed = true; initialize(); }
  }, 15000);
  document.addEventListener('liquid-ajax-cart:init', () => {
    clearTimeout(loadingTimer);
    loadingFailed = false;
    initialize();
  });
  addEventListener('pageshow', event => {
    if (event.persisted) reset();
    initialize();
  });
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  new MutationObserver(records => {
    const relevant = node => node.nodeType === 1 && (node.matches('product-form, [data-hdk-checkout], .add-2-cart') || node.querySelector('product-form, [data-hdk-checkout], .add-2-cart'));
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevant))) initialize();
  }).observe(document.documentElement, { childList: true, subtree: true });
  initialize();
})();
